import React from "react";
import StandardInstruction from "../StandardInstruction";
import ExpandableYouTubeEmbed from "../ExpandableYouTubeEmbed";
import ImageWithModal from "../ImageWithModal";

function PathBuilderInstructionsWalletConnection({ t, options }) {
  const show =
    options.downloadBlueWallet ||
    options.configureSeedSignerForBlueWallet ||
    options.exportXpubToBlueWallet ||
    options.importWalletIntoBlueWallet ||
    options.receiveBitcoinInBlueWallet ||
    options.createTransaction ||
    options.broadcastTransaction ||
    options.verifyTransaction;
  if (!show) return null;

  const showBlueWallet =
    options.downloadBlueWallet ||
    options.configureSeedSignerForBlueWallet ||
    options.exportXpubToBlueWallet ||
    options.importWalletIntoBlueWallet ||
    options.receiveBitcoinInBlueWallet ||
    options.createTransaction ||
    options.broadcastTransaction ||
    options.verifyTransaction;

  return (
    <div className="instruction-category-group">
      <h3 className="instruction-category-header">{t("pathBuilder.categories.walletConnection")}</h3>

      {showBlueWallet && (
        <div style={{ marginTop: "20px", marginBottom: "20px" }}>
          <h4 style={{ color: "#667eea", fontSize: "1em", fontWeight: 600, marginBottom: "12px" }}>{t("pathBuilder.categories.bluewallet")}</h4>
          {options.downloadBlueWallet && (
            <StandardInstruction
              title={t("pathBuilder.instructionTitles.downloadBlueWallet")}
              icon="📱"
              intro={
                <ExpandableYouTubeEmbed
                  videoId="https://www.youtube.com/watch?v=x0Ee35Ct0r4"
                  title={t("pathBuilder.instructionContent.downloadBlueWalletVideoLink")}
                />
              }
              steps={{
                items: [t("pathBuilder.instructionContent.downloadBlueWalletStep1")],
              }}
            />
          )}
          {options.configureSeedSignerForBlueWallet && (
            <StandardInstruction
              title={t("pathBuilder.instructionTitles.configureSeedSignerForBlueWallet")}
              icon="⚙️"
              steps={{
                items: [
                  t("pathBuilder.instructionContent.configureSeedSignerForBlueWalletStep1"),
                  t("pathBuilder.instructionContent.configureSeedSignerForBlueWalletStep2"),
                  t("pathBuilder.instructionContent.configureSeedSignerForBlueWalletStep3"),
                  t("pathBuilder.instructionContent.configureSeedSignerForBlueWalletStep4"),
                  t("pathBuilder.instructionContent.configureSeedSignerForBlueWalletStep5"),
                  t("pathBuilder.instructionContent.configureSeedSignerForBlueWalletStep6"),
                  t("pathBuilder.instructionContent.configureSeedSignerForBlueWalletStep7"),
                ],
              }}
            />
          )}
          {options.exportXpubToBlueWallet && (
            <StandardInstruction
              title={t("pathBuilder.instructionTitles.exportXpubToBlueWallet")}
              icon="📤"
              steps={{
                items: [
                  t("pathBuilder.instructionContent.exportXpubToBlueWalletStep1"),
                  t("pathBuilder.instructionContent.exportXpubToBlueWalletStep2"),
                  t("pathBuilder.instructionContent.exportXpubToBlueWalletStep3"),
                  t("pathBuilder.instructionContent.exportXpubToBlueWalletStep4"),
                  t("pathBuilder.instructionContent.exportXpubToBlueWalletStep5"),
                  t("pathBuilder.instructionContent.exportXpubToBlueWalletStep6"),
                  t("pathBuilder.instructionContent.exportXpubToBlueWalletStep7"),
                  t("pathBuilder.instructionContent.exportXpubToBlueWalletStep8"),
                  t("pathBuilder.instructionContent.exportXpubToBlueWalletStep9"),
                ],
              }}
              note={{
                label: t("pathBuilder.instructionContent.importantNote"),
                text: t("pathBuilder.instructionContent.exportXpubToBlueWalletNote"),
              }}
            />
          )}
          {options.importWalletIntoBlueWallet && (
            <StandardInstruction
              title={t("pathBuilder.instructionTitles.importWalletIntoBlueWallet")}
              icon="📥"
              steps={{
                items: [
                  {
                    content: (
                      <>
                        {t("pathBuilder.instructionContent.importWalletIntoBlueWalletStep1")}
                        <div style={{ marginTop: "12px" }}>
                          <ImageWithModal src={`${process.env.PUBLIC_URL}/assets/images/blue/image_01.jpg`} alt="Open BlueWallet app" />
                        </div>
                      </>
                    ),
                  },
                  {
                    content: (
                      <>
                        {t("pathBuilder.instructionContent.importWalletIntoBlueWalletStep2")}
                        <div style={{ marginTop: "12px" }}>
                          <ImageWithModal src={`${process.env.PUBLIC_URL}/assets/images/blue/image_02.jpg`} alt="BlueWallet home screen" />
                        </div>
                      </>
                    ),
                  },
                  t("pathBuilder.instructionContent.importWalletIntoBlueWalletStep3"),
                  t("pathBuilder.instructionContent.importWalletIntoBlueWalletStep4"),
                  t("pathBuilder.instructionContent.importWalletIntoBlueWalletStep5"),
                  t("pathBuilder.instructionContent.importWalletIntoBlueWalletStep6"),
                  t("pathBuilder.instructionContent.importWalletIntoBlueWalletStep7"),
                  t("pathBuilder.instructionContent.importWalletIntoBlueWalletStep8"),
                  t("pathBuilder.instructionContent.importWalletIntoBlueWalletStep9"),
                  t("pathBuilder.instructionContent.importWalletIntoBlueWalletStep10"),
                  t("pathBuilder.instructionContent.importWalletIntoBlueWalletStep11"),
                ],
              }}
              note={{
                label: t("pathBuilder.instructionContent.importantNote"),
                text: t("pathBuilder.instructionContent.importWalletIntoBlueWalletNote"),
              }}
            />
          )}
          {options.receiveBitcoinInBlueWallet && (
            <StandardInstruction
              title={t("pathBuilder.instructionTitles.receiveBitcoinInBlueWallet")}
              icon="💰"
              steps={{
                items: [
                  t("pathBuilder.instructionContent.receiveBitcoinInBlueWalletStep1"),
                  t("pathBuilder.instructionContent.receiveBitcoinInBlueWalletStep2"),
                  t("pathBuilder.instructionContent.receiveBitcoinInBlueWalletStep3"),
                  t("pathBuilder.instructionContent.receiveBitcoinInBlueWalletStep4"),
                  t("pathBuilder.instructionContent.receiveBitcoinInBlueWalletStep5"),
                ],
              }}
              note={{
                label: t("pathBuilder.instructionContent.importantNote"),
                text: t("pathBuilder.instructionContent.receiveBitcoinInBlueWalletNote"),
              }}
            />
          )}
          {options.createTransaction && (
            <StandardInstruction
              title={t("pathBuilder.instructionTitles.createTransaction")}
              icon="📱"
              steps={{
                items: [
                  t("pathBuilder.instructionContent.createTransactionStep1"),
                  t("pathBuilder.instructionContent.createTransactionStep2"),
                  t("pathBuilder.instructionContent.createTransactionStep3"),
                  t("pathBuilder.instructionContent.createTransactionStep4"),
                  t("pathBuilder.instructionContent.createTransactionStep5"),
                  t("pathBuilder.instructionContent.createTransactionStep6"),
                  t("pathBuilder.instructionContent.createTransactionStep7"),
                  t("pathBuilder.instructionContent.createTransactionStep8"),
                ],
              }}
            />
          )}
          {options.broadcastTransaction && (
            <StandardInstruction
              title={t("pathBuilder.instructionTitles.broadcastTransaction")}
              icon="📡"
              steps={{
                items: [
                  t("pathBuilder.instructionContent.broadcastTransactionStep1"),
                  t("pathBuilder.instructionContent.broadcastTransactionStep2"),
                  t("pathBuilder.instructionContent.broadcastTransactionStep3"),
                  t("pathBuilder.instructionContent.broadcastTransactionStep4"),
                  t("pathBuilder.instructionContent.broadcastTransactionStep5"),
                  t("pathBuilder.instructionContent.broadcastTransactionStep6"),
                  t("pathBuilder.instructionContent.broadcastTransactionStep7"),
                  t("pathBuilder.instructionContent.broadcastTransactionStep8"),
                  t("pathBuilder.instructionContent.broadcastTransactionStep9"),
                ],
              }}
              note={{
                label: t("pathBuilder.instructionContent.importantNote"),
                text: t("pathBuilder.instructionContent.broadcastTransactionNote"),
              }}
            />
          )}
          {options.verifyTransaction && (
            <StandardInstruction
              title={t("pathBuilder.instructionTitles.verifyTransaction")}
              icon="✅"
              steps={{
                items: [
                  t("pathBuilder.instructionContent.verifyTransactionStep1"),
                  t("pathBuilder.instructionContent.verifyTransactionStep2"),
                  t("pathBuilder.instructionContent.verifyTransactionStep3"),
                  t("pathBuilder.instructionContent.verifyTransactionStep4"),
                ],
              }}
              note={{
                label: t("pathBuilder.instructionContent.importantNote"),
                text: t("pathBuilder.instructionContent.verifyTransactionNote"),
              }}
            />
          )}
        </div>
      )}

      <div style={{ marginTop: "20px", marginBottom: "20px" }}>
        <h4 style={{ color: "#667eea", fontSize: "1em", fontWeight: 600, marginBottom: "12px" }}>{t("pathBuilder.categories.bullWallet")}</h4>
        {/* Bull Wallet instructions will be added here */}
      </div>
    </div>
  );
}

export default PathBuilderInstructionsWalletConnection;
